import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Field, Form, useField, useFormikContext } from 'formik';
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  Typography,
  makeStyles
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
// import FacebookIcon from 'src/icons/Facebook';
// import GoogleIcon from 'src/icons/Google';
import Page from 'src/components/Page';
import { userActions } from './../../_actions';
import error from './../../config/error.json';
var CryptoJS = require('crypto-js');

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const ChangePassword = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [response, setResponse] = useState({});
  const [keyData, setKeyData] = useState({});
  const params = useParams();
  const [passwordValue, setPasswordValue] = useState('');
  const [errora, setError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const handleKeyUp = e => {
    var value = e.target.value;
    if (value !== passwordValue) {
      setErrorText('Password Dindt Match!');
      setError(true);
    } else {
      setErrorText('');
      setError(false);
    }
  };

  // const { values, touched, setFieldValue, errors } = useFormikContext();

  // const validate = values => {
  //   const errors = {};
  //   console.log(values);

  //   // if (!values.email) {
  //   //   errors.email = 'Required';
  //   // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
  //   //   errors.email = 'Invalid email address';
  //   // }

  //   // //...

  //   return errors;
  // };

  // useEffect(() => {

  //   if (password ==! password2) {
  //     errors = "password not match";
  //   }
  // }, [password2, touched.password2, setFieldValue, props.name]);

  useEffect(() => {
    var key = process.env.REACT_APP_KEY;
    var iv = process.env.REACT_APP_IV;
    var cipherParams2 = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Hex.parse(params.key)
    });
    var decrypted2 = CryptoJS.AES.decrypt(
      cipherParams2,
      CryptoJS.enc.Hex.parse(key),
      {
        iv: CryptoJS.enc.Hex.parse(iv)
      }
    );
    var d = decrypted2.toString(CryptoJS.enc.Utf8);
    var d = JSON.parse(d);
    setKeyData(d);
    var email = d.email;
    var oldPassword = d.password;
    var dat = new Date(d.date);
    var event2 = new Date();
    // console.log(email, dat.toISOString());
    if (dat.getHours() === event2.getHours()) {
      console.log('trueeeeee');
    } else {
      console.log('false');
      navigate('wrong', { replace: true });
    }
  }, []);

  return (
    <Page className={classes.root} title="Login">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          {response.hasOwnProperty('type') ? (
            response.type === 'USERS_LOGIN_FAILURE' ? (
              <Alert severity="error">
                <AlertTitle>Error</AlertTitle>
                {error[response.error.rCode.toString()]}{' '}
                <strong>Please try again</strong>
              </Alert>
            ) : (
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                This is a success alert — <strong>check it out!</strong>
              </Alert>
            )
          ) : (
            ''
          )}

          <Formik
            initialValues={{
              password2: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              password2: Yup.string()
                .max(255)
                .required('Password is required'),
              password: Yup.string()
                .max(255)
                .required('Password is required')
            })}
            onSubmit={values => {
              var key = process.env.REACT_APP_KEY;
              var iv = process.env.REACT_APP_IV;
              var encrypted = CryptoJS.AES.encrypt(
                CryptoJS.enc.Utf8.parse(
                  JSON.stringify({
                    email: keyData.email,
                    oldPassword: keyData.password,
                    newPassword: values.password2,
                    date: new Date()
                  })
                ),
                CryptoJS.enc.Hex.parse(key),
                {
                  iv: CryptoJS.enc.Hex.parse(iv)
                }
              );
              var c = encrypted.ciphertext.toString();
              console.log(encrypted.ciphertext.toString());
              let res = userActions.changePassword(c);
              return res.then(x => {
                console.log(x);
                if (x.message === 'successfull') {
                  setResponse(x);
                  navigate('/', { replace: true });
                  return null;
                } else {
                  navigate('/', { replace: true });
                  return null;
                }
              });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              validate
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={3}>
                  <Typography color="textPrimary" variant="h2">
                    Change Password
                  </Typography>
                  <Typography
                    color="textSecondary"
                    gutterBottom
                    variant="body2"
                  >
                    You can now change your password
                  </Typography>
                </Box>

                <TextField
                  error={Boolean(touched.password2 && errors.password2)}
                  fullWidth
                  helperText={touched.password2 && errors.password2}
                  label="New Password"
                  margin="normal"
                  name="password2"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onKeyUp={e => {
                    setPasswordValue(e.target.value);
                  }}
                  type="password"
                  value={values.password2}
                  variant="outlined"
                />
                <TextField
                  error={errora}
                  fullWidth
                  helperText={errorText}
                  label="Confirm Password"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onKeyUp={handleKeyUp}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box my={2}>
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Change Password now
                  </Button>
                </Box>
                {/* <Typography color="textSecondary" variant="body1">
                  Don&apos;t have an account?{' '}
                  <Link component={RouterLink} to="/register" variant="h6">
                    Sign up
                  </Link>
                </Typography>
                <Typography color="textSecondary" variant="body1">
                  Can&apos;t Login?{' '}
                  <Link component={RouterLink} to="/forget-password" variant="h6">
                    Change Password
                  </Link>
                </Typography> */}
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </Page>
  );
};

export default ChangePassword;
